/*
 * @Author: changcheng
 * @LastEditTime: 2023-06-14 09:44:02
 */
import User from "@/img/user.png";
import Manage from "@/img/manage.png";
import axios from "@/axios/axios";
import { useEffect, useState } from "react";
import { Input, Button } from "antd";
import "./index.less";
export const MessageBoard = () => {
  const [userMessageList, setUserMessageList] = useState([]);
  const [message, setMessage] = useState("");
  useEffect(() => {
    getMessageList();
  }, []);
  /**
   * 获取消息列表
   */
  const getMessageList = async () => {
    const { data = [] } = await axios.post(
      "/shop/front/ce/item/message/info",
      {}
    );
    setUserMessageList(data);
  };
  /**
   * 保存用户消息
   */
  const saveMessage = async () => {
    await axios.post("/shop/front/ce/item/message/save", {
      message,
    });
    getMessageList();
    setMessage("");
  };
  return (
    <div className="message-container">
      <div className="message-top">
        {userMessageList.map((item: any) => (
          <>
            {item.messageType === 1 && (
              <div className={`message-content message-manage`}>
                <div>
                  <p>{item.createTime}</p>
                  <p>{item.message}</p>
                </div>
                <p>
                  <img
                    src={item.messageType === 1 ? User : Manage}
                    width="30px"
                  />
                </p>
              </div>
            )}
            {item.messageType === 2 && (
              <div className={`message-content`}>
                <p>
                  <img
                    src={item.messageType === 1 ? User : Manage}
                    width="30px"
                  />
                </p>
                <div>
                  <p>{item.createTime}</p>
                  <p>{item.message}</p>
                </div>
              </div>
            )}
          </>
        ))}
      </div>
      <Input.Group compact>
        <Input
          style={{ width: "calc(100% - 70px)" }}
          onChange={(e) => {
            setMessage(e.target.value);
          }}
          value={message}
        />
        <Button type="primary" onClick={saveMessage}>
          提交
        </Button>
      </Input.Group>
    </div>
  );
};
